import {
  Box,
  Collapse,
  Text,
  VStack,
  HStack,
  Checkbox,
  Select,
  NumberInput,
  NumberInputField,
} from '@chakra-ui/react';

import { useAnswerCodes } from '../../hooks';
import { ValidatedField, CurrencyInput } from '..';
import type { CoverageSectionProps } from './types';

const PropertyInStorageSection = ({
  coverages,
  updateCoverage,
  isLoadingCodes,
}: CoverageSectionProps) => {
  const { getOptions } = useAnswerCodes();

  return (
    <Box>
      <HStack mb={3}>
        <Text fontWeight="700">Property in Storage</Text>
        <Checkbox
          isChecked={coverages.property_in_storage_enabled}
          onChange={(e) =>
            updateCoverage('property_in_storage_enabled', e.target.checked)
          }
          colorScheme="blue"
        />
      </HStack>
      <Collapse in={coverages.property_in_storage_enabled} animateOpacity>
        <VStack align="stretch" spacing={3}>
          <Checkbox
            isChecked={coverages.property_in_storage_include_burglary}
            onChange={(e) =>
              updateCoverage(
                'property_in_storage_include_burglary',
                e.target.checked,
              )
            }
            colorScheme="blue"
          >
            <Text fontSize="sm">Include Burglary</Text>
          </Checkbox>
          <HStack spacing={4} align="flex-end">
            <ValidatedField
              itemPath="location"
              fieldPath="coverages.property_in_storage_coverage_type"
              label="Coverage Type"
              labelSize="xs"
              formControlProps={{ flex: 2 }}
            >
              <Select
                variant="main"
                height={30}
                value={coverages.property_in_storage_coverage_type || ''}
                onChange={(e) =>
                  updateCoverage(
                    'property_in_storage_coverage_type',
                    e.target.value,
                  )
                }
                isDisabled={isLoadingCodes}
              >
                {getOptions('property_in_storage_coverage_type').map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </Select>
            </ValidatedField>
            <ValidatedField
              itemPath="location"
              fieldPath="coverages.property_in_storage_value_cad"
              label="Value"
              labelSize="xs"
              formControlProps={{ flex: 1 }}
            >
              <CurrencyInput
                value={coverages.property_in_storage_value_cad ?? ''}
                onChange={(_, value) =>
                  updateCoverage('property_in_storage_value_cad', value)
                }
              />
            </ValidatedField>
            <ValidatedField
              itemPath="location"
              fieldPath="coverages.property_in_storage_percent_to_insure"
              label="Percent to Insure"
              labelSize="xs"
              formControlProps={{ flex: 1 }}
            >
              <NumberInput
                variant="main"
                size="sm"
                min={1}
                max={100}
                value={coverages.property_in_storage_percent_to_insure ?? ''}
                onChange={(valueString) =>
                  updateCoverage(
                    'property_in_storage_percent_to_insure',
                    valueString ? Number(valueString) : null,
                  )
                }
              >
                <NumberInputField height={30} />
              </NumberInput>
            </ValidatedField>
          </HStack>
        </VStack>
      </Collapse>
    </Box>
  );
};

export default PropertyInStorageSection;
